module.exports = __webpack_public_path__ + "static/father-daughter-market-square.cc6e2910.jpg";